import { render, staticRenderFns } from "./SectionsList.vue?vue&type=template&id=16d1f2d0&scoped=true"
import script from "./SectionsList.vue?vue&type=script&lang=ts"
export * from "./SectionsList.vue?vue&type=script&lang=ts"
import style0 from "./SectionsList.vue?vue&type=style&index=0&id=16d1f2d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1f2d0",
  null
  
)

export default component.exports